import { useCallback } from "react";
import { useWeb3React, UnsupportedChainIdError } from "@web3-react/core";
import { useToast } from "../state/hooks";
import { connectorsByName } from "../utils/web3React";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import useWeb3ErrorToast from "../utils/useWeb3ErrorToast";

const useAuth = () => {
  const { toastError } = useToast();
  const { handleError } = useWeb3ErrorToast();

  let chainid = process.env.REACT_APP_CHAIN_ID;
  const TomiPayBol = localStorage.getItem("IsTomipay");

  const login = async (connectorID) => {
    const connector = connectorsByName[connectorID];

    if (!connector) {
      toastError("Can't find connector", "The connector config is wrong");
      return;
    }

    try {
      if (connectorID === "injected") {
        await connector.activate(chainid);
      } else {
        await connector.activate();
      }
    } catch (error) {
      console.error("Login error:", error);
      handleError(error);
    }
  };

  const logout = async (connectorID) => {
    const connector = connectorsByName[connectorID];

    if (!connector) {
      toastError("Can't find connector", "The connector config is wrong");
      return;
    }

    try {
      if (connector?.disconnect) {
        await connector.disconnect(); // ends wallet session
      }
      if (connector?.deactivate) {
        await connector.deactivate();
      } else {
        await connector.resetState();
      }
    } catch (error) {
      console.error("Logout error:", error);
      handleError(error);
    }
  };

  return { login, logout };
};

export default useAuth;
